/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentListSyncedUsers } from "../funcs/agentListSyncedUsers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSyncedUsersResult } from "../models/components/listsyncedusersresult.js";
import {
  ListSyncedAgentUsersRequest,
  ListSyncedAgentUsersSecurity,
} from "../models/operations/listsyncedagentusers.js";
import { unwrapAsync } from "../types/fp.js";
export type SyncedAgentUsersQueryData = ListSyncedUsersResult;

export function prefetchSyncedAgentUsers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSyncedAgentUsersRequest | undefined,
  security?: ListSyncedAgentUsersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSyncedAgentUsersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSyncedAgentUsersQuery(
  client$: GramCore,
  request?: ListSyncedAgentUsersRequest | undefined,
  security?: ListSyncedAgentUsersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SyncedAgentUsersQueryData>;
} {
  return {
    queryKey: queryKeySyncedAgentUsers({ gramSession: request?.gramSession }),
    queryFn: async function syncedAgentUsersQueryFn(
      ctx,
    ): Promise<SyncedAgentUsersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(agentListSyncedUsers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySyncedAgentUsers(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "agent", "listSyncedUsers", parameters];
}
